import BICash from './BICash.f';
import withGlobalModals from 'hocs/withGlobalModals';

export default withGlobalModals(BICash);
